import React from 'react'
import { Mail, Lock, User, Phone, Eye, EyeOff } from 'react-feather'

interface DarkAuthInputProps {
  value: string
  handleFunction: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder: string
  type: string
  icon: 'email' | 'password' | 'user' | 'phone'
  error?: string
  showPasswordToggle?: boolean
  onTogglePassword?: () => void
  isPasswordVisible?: boolean
}

const DarkAuthInput = ({
  value,
  handleFunction,
  placeholder,
  type,
  icon,
  error,
  showPasswordToggle,
  onTogglePassword,
  isPasswordVisible
}: DarkAuthInputProps) => {

  const getIcon = () => {
    const iconClass = "w-5 h-5 text-accent-teal"
    switch (icon) {
      case 'email':
        return <Mail className={iconClass} />
      case 'password':
        return <Lock className={iconClass} />
      case 'user':
        return <User className={iconClass} />
      case 'phone':
        return <Phone className={iconClass} />
      default:
        return <User className={iconClass} />
    }
  }

  return (
    <div className="w-full mb-4">
      <div className={`
        flex items-center gap-3 px-4 py-3.5 md:py-3
        bg-dark-input border rounded-xl
        transition-all duration-200
        focus-within:border-accent-teal focus-within:ring-1 focus-within:ring-accent-teal/50
        ${error ? 'border-red-500' : 'border-dark-border'}
      `}>
        {getIcon()}
        <input
          className="flex-1 bg-transparent text-white placeholder-gray-500 outline-none text-base md:text-sm min-h-[24px]"
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={handleFunction}
          autoCapitalize="none"
          autoComplete={type === 'password' ? 'current-password' : type === 'email' ? 'email' : 'off'}
        />
        {showPasswordToggle && (
          <button
            type="button"
            onClick={onTogglePassword}
            className="text-gray-500 hover:text-gray-300 active:text-gray-100 transition-colors p-1 -mr-1"
          >
            {isPasswordVisible ? (
              <EyeOff className="w-5 h-5" />
            ) : (
              <Eye className="w-5 h-5" />
            )}
          </button>
        )}
      </div>
      {error && (
        <p className="mt-1.5 text-xs text-red-400 pl-1">{error}</p>
      )}
    </div>
  )
}

export default DarkAuthInput
